export default class Cookies {
    public set(cname: string, cvalue: string, exdays: number): void {
        let d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

        let cookie = [
            `${cname}=${cvalue}`,
            `expires=${d.toUTCString()}`,
            `path=/`
        ];

        document.cookie = cookie.join(";");
    }

    public get(cname: string): string {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(";");
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }
}



// WEBPACK FOOTER //
// ./src/ts/classes/Cookies.ts